<template>
    <div
        class="p-4 form-control-muted d-flex flex-column align-items-center pointer"
        @click="$emit('activateExternalContent')">
        <base-button
            :title="iframeInfo"
            type="muted"
            @click.stop="$emit('activateExternalContent')">
            <font-awesome-icon
                size="lg"
                icon="eye-slash" />
        </base-button>
        <span class="text-sm text-center">{{ $t('core.thirdPartyContent') }}</span>
    </div>
</template>

<script>
export default {
    name: "IFramePlaceholder",
    props: {
        iframeInfo: {
            type: String,
        }
    }
}
</script>

<style scoped>

</style>
